<!--
 * @Author: your name
 * @Date: 2020-12-13 09:57:16
 * @LastEditTime: 2021-08-09 15:54:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklookweb\mooklook_ch\src\components\Footer.vue
-->
<template>
  <div class="footer">
    <div class="layer">
      <div class="about" v-if="aboutItem">
        <div class="title" v-if="lange == 'Ch'">{{ aboutItem.title }}</div>
        <div class="item">
          <p
            class="txt"
            v-for="(val, index) in aboutItem.childrens"
            :key="index"
            @click="jumpPage(index)"
          >
            {{ val.title }}
          </p>
        </div>
      </div>
      <div class="law">
        <!-- <div class="title">法律</div>
        <div class="item">
          <p class="txt" v-for="(val, index) in 3" :key="index">{{ index }}</p>
        </div> -->
      </div>
      <div class="record">
        <div class="foot_icon">
          <img class="auto-img" src="../assets/icon/foot_icon.png" />
        </div>
        <div class="">
          <div
            class="record_txt name"
            :style="{
              textAlign: isPhone || keepRecord.length == 1 ? 'center' : 'right',
            }"
          >
            {{ keepRecord[0].tit }}
          </div>
          <div
            class="record_txt ICP"
            :style="{ textAlign: isPhone ? 'center' : '' }"
          >
            {{ keepRecord[1].tit }}
          </div>
          <div
          v-if="keepRecord[2]"
            @click="onRecord"
            class="record_txt ICP"
            :style="{ textAlign: isPhone ? 'center' : '' }"
          >
            {{ keepRecord[2].tit }}
          </div>
        </div>
      </div>
    </div>
    <!-- <el-row class="footer-content" :gutter="20" justify="center">
      <el-col :span="isPhone || keepRecord.length==1?24:12">
        <div class="record_txt" :style="{textAlign:isPhone||keepRecord.length==1?'center':'right'}">{{keepRecord[0].tit}}</div>
      </el-col>
      <el-col :span="isPhone?24:12" v-if="keepRecord.length>1" >
        <div @click="onRecord" class="record_txt" :style="{textAlign:isPhone?'center':''}">{{keepRecord[1].tit}}</div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import { categoryList,getArticleList } from "@/api/api";
export default {
  name: "Footer",
  props: ["lang"],
  data() {
    return {
      questionList: [],
      keepRecord: [],
      Hotline: [],
      isPhone: document.body.clientWidth < 920,
      aboutItem: {},
    };
  },
  created() {
    this.switchLange(this.lange);
    this.getProductList();
  },
  methods: {
    // 切换语言
    switchLange(lange) {
      switch (lange) {
        case "JPN":
          this.keepRecord = [
            { tit: "株式会社花奈本舗美業研究所" },
            { tit: "電話：045-550-5909" },
            // { tit: "粤ICP备19076733号" },
          ];
          break;
        default:
          this.keepRecord = [
            { tit: "花奈本铺贸易（广州）有限公司" },
            { tit: "电话号码：045-550-5909" },
            { tit: "粤ICP备19076733号" },
          ];
      }
    },
    // 获取专利
    getArticleList(min = 1, max = 6) {
      let params = {
        articleTypeId: this.lange == "Ch" ? 47 : 49,
        pageIndex: min,
        pageSize: max,
      };
      getArticleList(params).then((res) => {
        this.articleList = res.data.data.data;
        this.$router.push({
          name: "AOG",
          query: {
            id: this.articleList[0].id,
            detail: JSON.stringify(this.articleList[0]),
          },
        });
      });
    },
    jumpPage(index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: "Home",
          });
          document.body.scrollTop = document.documentElement.scrollTop = 0;
          break;
        case 1:
          this.$router.push({
            name: "Product",
            query: {
              id: this.productMenu[0].id,
              detail: JSON.stringify(this.productMenu[0]),
              index: "1-0",
            },
          });
          break;
        case 2:
          this.getArticleList();
          break;
        case 3:
          this.$router.push({
            name: "Introduce",
            query: {
              id: this.Introduce[0].id,
              detail: JSON.stringify(this.Introduce[0]),
              index: "1-0",
            },
          });
          break;
      }
    },
    goPage(item) {
      this.$router.push({ name: "FooterView", query: { id: item.id } });
    },
    onRecord() {
      window.location.href = "https://beian.miit.gov.cn";
    },
    // 产品系列菜单栏
    getProductList() {
      categoryList({ lang: this.lange == "JPN" ? "ja_JP" : "" }).then((res) => {
        if (res.data.code == 0) {
          // 关于
          this.aboutItem = res.data.data[4];
          // 产品系列
          this.productMenu = res.data.data[0] && res.data.data[0].childrens;
          // 明星单品
          this.starItem = res.data.data[1] && res.data.data[1].childrens;
          // 品牌介绍
          this.Introduce = res.data.data[2] && res.data.data[2].childrens;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  overflow: hidden;
  padding: 62px 0 52px;
  .layer {
    max-width: 1440px;
  min-width: 1240px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    .about,
    .law {
      width: 204px;
      .title {
        padding-bottom: 6px;
        font-size: 18px;
        font-weight: bold;
        color: #212121;
        border-bottom: 1px solid #876d4b;
        display: inline-block;
        margin-bottom: 20px;
      }
      .item {
        font-size: 14px;
        font-weight: 400;
        color: #212121;
        .txt {
          padding-bottom: 13px;
          cursor: pointer;
        }
      }
    }
    .record {
      display: flex;
      &_txt {
        font-size: 14px;
        color: #3e3a39;
        cursor: pointer;
      }
      .name {
        font-size: 18px;
        font-weight: bold;
        color: #212121;
      }
      .ICP {
        font-size: 14px;
        font-weight: 400;
        color: #878787;
        margin-top: 12px;
      }
      &_txt:last-child:hover {
        color: #876d4b;
      }
    }
  }
}
</style>
